(() => {
  const headers = new WeakMap();
  // Footer sign-up without a page reload. Shopify's spam check (hCaptcha) intercepts the submit,
  // adds a pass token, then calls form.submit(). We take over that final step and send the same
  // form data, token included, in the background. Anything unexpected falls back to the normal
  // full-page post, so a sign-up is never lost.
  const okfTokenNames = ['h-captcha-response', 'g-recaptcha-response', 'recaptcha-v3-token'];
  const okfHasToken = form => okfTokenNames.some(n => form.elements[n] && form.elements[n].value);
  const okfNative = form => {
    form.dataset.okfNative = '1';
    HTMLFormElement.prototype.submit.call(form);
  };
  const okfSend = form => {
    if (form.dataset.okfBusy) return;
    if (!window.fetch || !window.FormData) return okfNative(form);
    form.dataset.okfBusy = '1';
    const card = form.closest('.okf-news');
    const button = form.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    const action = (form.getAttribute('action') || '/contact').split('#')[0];
    fetch(action, {method: 'POST', body: new FormData(form), credentials: 'same-origin'})
      .then(response => response.text().then(html => ({response, html})))
      .then(({response, html}) => {
        const ok = response.ok && !/\/challenge/.test(response.url) &&
          (/[?&]customer_posted=true/.test(response.url) || html.indexOf('class="okf-news-ok"') !== -1);
        if (!ok) throw new Error('not confirmed');
        const done = document.createElement('p');
        done.className = 'okf-news-ok';
        done.setAttribute('role', 'status');
        done.textContent = (card && card.dataset.okfThanks) || 'Thanks for subscribing';
        form.replaceWith(done);
      })
      .catch(() => { delete form.dataset.okfBusy; if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } okfNative(form); });
  };
  const okfWire = () => {
    const form = document.getElementById('OkfNewsletter');
    if (!form || form.dataset.okfWired) return;
    form.dataset.okfWired = '1';
    // Shopify's spam check finishes by calling form.submit(); route that through okfSend.
    form.submit = function () { if (this.dataset.okfNative) return HTMLFormElement.prototype.submit.call(this); okfSend(this); };
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form || form.id !== 'OkfNewsletter' || form.dataset.okfNative) return;
    okfWire();
    // A submit that already carries the spam-check token (or a form with no spam check at all
    // after a moment) is ours to send.
    if (okfHasToken(form)) { event.preventDefault(); okfSend(form); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', okfWire); else okfWire();
  // After the footer sign-up posts, Shopify reloads the page at #OkfNewsletter. Content above it
  // (reviews, product grids) loads afterwards and pushes it down, so keep it in view until the page settles.
  if (location.hash === '#OkfNewsletter' || /[?&]customer_posted=true/.test(location.search)) {
    let stop = false;
    const quit = () => { stop = true; };
    ['touchstart', 'wheel', 'keydown'].forEach(t => window.addEventListener(t, quit, {passive: true, once: true}));
    const pin = () => {
      if (stop) return;
      const el = document.getElementById('OkfNewsletter') || document.querySelector('.okf-news');
      if (!el || !window.matchMedia('(max-width: 767px)').matches) return;
      const card = el.closest('.okf-news') || el;
      card.scrollIntoView({block: 'center'});
    };
    [0, 300, 800, 1500, 2500, 4000, 6000].forEach(ms => setTimeout(pin, ms));
    window.addEventListener('load', () => setTimeout(pin, 50));
  }
  const wireFooter = () => {
    document.querySelectorAll('[data-ok-rewards]:not([data-ok-bound])').forEach(link => {
      link.dataset.okBound = 'true';
      link.addEventListener('click', event => {
        const base = document.querySelector('.stamped-rewards-base');
        if (!base || !window.StampedFn || typeof window.StampedFn.toggleRewardsModal !== 'function') return; // go to the rewards page
        event.preventDefault();
        try { if (!base.classList.contains('opened')) window.StampedFn.toggleRewardsModal(); }
        catch (_) { location.href = link.href; return; }
        setTimeout(() => { if (!base.classList.contains('opened')) location.href = link.href; }, 700);
      });
    });
    document.querySelectorAll('[data-ok-top]:not([data-ok-bound])').forEach(link => {
      link.dataset.okBound = 'true';
      link.addEventListener('click', () => {
        requestAnimationFrame(() => {
          const target = document.getElementById('OkSiteHeader');
          if (!target) return;
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        });
      });
    });
  };
  const init = () => {
    wireFooter();
    const mobile = window.matchMedia('(max-width: 767px)');
    const nativeMobile = window.matchMedia('(max-width: 991px)');
    const header = document.getElementById('OkSiteHeader');
    if (!header || headers.has(header)) return;
    header.dataset.okShellReady = 'true';
    const searchOriginals = new WeakMap();
    const syncSearchPlaceholder = () => {
      if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
      header.querySelectorAll('input.site-header__search-input').forEach(input => {
        const current = input.getAttribute('placeholder') || '';
        const compact = 'Search products or brands';
        if (current !== compact) searchOriginals.set(input, current);
        const next = mobile.matches ? compact : searchOriginals.get(input);
        if (next !== undefined && current !== next) input.setAttribute('placeholder', next);
      });
    };
    const searchObserver = new MutationObserver(syncSearchPlaceholder);
    header.querySelectorAll('input.site-header__search-input').forEach(input => searchObserver.observe(input, {attributes:true, attributeFilter:['placeholder']}));
    syncSearchPlaceholder();
    const menu = header.querySelector('#OkMainMenu');
    const trigger = header.querySelector('.mobile-menu-trigger');
    const closeMenu = header.querySelector('#close_menu');
    let menuWasOpen = false;
    const resetMenu = () => {
      if (!menu) return;
      menuWasOpen = false;
      menu.classList.remove('active', 'submenu_active');
      header.querySelector('.menu-overlay')?.classList.remove('active');
      document.body.classList.remove('lock_scroll');
      menu.querySelectorAll('.sub-menu.active,.mobile-menu-head.active').forEach(el => el.classList.remove('active'));
      menu.querySelectorAll('.sub-menu').forEach(el => el.style.removeProperty('animation'));
      const title = menu.querySelector('.current-menu-title');
      if (title) title.textContent = '';
    };
    const syncMenu = () => {
      if (!menu || !trigger) return;
      header.querySelectorAll('.mobile-menu-trigger,#close_menu,.go-back').forEach(control => {
        if (mobile.matches) { control.setAttribute('role', 'button'); control.setAttribute('tabindex', '0'); }
        else { control.removeAttribute('role'); control.removeAttribute('tabindex'); }
      });
      const open = menu.classList.contains('active');
      trigger.setAttribute('aria-expanded', String(open));
      menu.inert = nativeMobile.matches && !open;
      if (mobile.matches && open) {
        // Start the menu below the header and below the logo, so the logo is never cut off.
        const logo = header.querySelector('.logo img, .logo');
        const logoBottom = logo ? logo.getBoundingClientRect().bottom + 8 : 0;
        const bottom = Math.max(0, Math.min(window.innerHeight - 80, logoBottom || header.getBoundingClientRect().bottom));
        header.style.setProperty('--ok-menu-top', `${bottom}px`);
        if (!menuWasOpen) closeMenu?.focus();
      } else if (mobile.matches && menuWasOpen && !open) {
        trigger.focus();
      }
      menuWasOpen = mobile.matches && open;
    };
    const observer = new MutationObserver(syncMenu);
    if (menu) observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
    const onBreakpointChange = () => {
      syncSearchPlaceholder();
      header.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      resetMenu();
      syncMenu();
    };
    mobile.addEventListener('change', onBreakpointChange);
    nativeMobile.addEventListener('change', onBreakpointChange);
    window.addEventListener('resize', syncMenu, { passive: true });
    resetMenu();
    syncMenu();
    const onKeydown = event => {
      if (mobile.matches && (event.key === 'Enter' || event.key === ' ') && event.target.matches('.mobile-menu-trigger,#close_menu,.go-back')) {
        event.preventDefault();
        event.target.click();
        return;
      }
      if (!mobile.matches || !menu?.classList.contains('active')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu?.click();
      } else if (event.key === 'Tab') {
        const items = [closeMenu, ...menu.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')].filter(el => el && !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        if (!items.length) return;
        event.preventDefault();
        const current = items.indexOf(document.activeElement);
        const next = current < 0 ? 0 : (current + (event.shiftKey ? -1 : 1) + items.length) % items.length;
        items[next].focus();
      }
    };
    header.addEventListener('keydown', onKeydown);
    const onClick = event => {
      const button = event.target.closest('[data-ok-open]');
      if (button) {
        const dialog = document.getElementById(button.dataset.okOpen);
        if (dialog?.showModal) dialog.showModal();
      }
      event.target.closest('[data-ok-close]')?.closest('dialog')?.close();
    };
    header.addEventListener('click', onClick);
    const onPageShow = () => {resetMenu(); syncMenu();};
    window.addEventListener('pageshow', onPageShow);
    const cleanup = () => {
      observer.disconnect();
      searchObserver.disconnect();
      mobile.removeEventListener('change', onBreakpointChange);
      nativeMobile.removeEventListener('change', onBreakpointChange);
      window.removeEventListener('resize', syncMenu);
      window.removeEventListener('pageshow', onPageShow);
      header.removeEventListener('keydown', onKeydown);
      header.removeEventListener('click', onClick);
      header.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      resetMenu();
      delete header.dataset.okShellReady;
      headers.delete(header);
    };
    headers.set(header, {cleanup});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    const header = event.target.querySelector('#OkSiteHeader');
    if (header) headers.get(header)?.cleanup();
  });
})();
// Mobile menu (design C). Phones only: on wider screens the theme's own menu runs as before.
(() => {
  const phone = window.matchMedia('(max-width: 767px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const CLOSE_MS = 320, SETTLE_MS = 380;
  let root, lastFocus, savedY = 0, locked = false, closeTimer, openedAt = 0;
  const views = () => [...root.querySelectorAll('.okm-view')];
  const home = () => root.querySelector('[data-okm-view="home"]');
  const trigger = () => document.querySelector('#OkSiteHeader .mobile-menu-trigger');
  const isOpen = () => !!root && root.classList.contains('is-open');

  const lockScroll = () => {
    if (locked) return; // already locked (e.g. reopened mid-close): keep the original position
    locked = true;
    savedY = window.scrollY;
    const b = document.body.style;
    b.position = 'fixed'; b.top = `-${savedY}px`; b.left = '0'; b.right = '0'; b.width = '100%';
  };
  const unlockScroll = () => {
    if (!locked) return;
    locked = false;
    const b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, savedY);
  };
  const loadImages = () => root && root.querySelectorAll('img[data-okm-src]').forEach(img => {
    img.addEventListener('load', () => img.classList.add('is-loaded'), {once: true});
    img.src = img.dataset.okmSrc; img.removeAttribute('data-okm-src');
  });
  const resetViews = () => views().forEach(v => {
    const isHome = v.dataset.okmView === 'home';
    v.classList.toggle('is-active', isHome); v.classList.remove('is-behind');
    v.setAttribute('aria-hidden', String(!isHome)); v.inert = !isHome;
  });
  const setExpanded = v => trigger()?.setAttribute('aria-expanded', String(v));
  const open = () => {
    if (!root || isOpen()) return;
    const reopening = root.classList.contains('is-closing');
    clearTimeout(closeTimer);
    if (!reopening) { lastFocus = document.activeElement; resetViews(); }
    loadImages();
    root.hidden = false; root.classList.remove('is-closing');
    if (!reopening) views().forEach(v => { v.scrollTop = 0; }); // must run while visible
    lockScroll();
    void root.offsetWidth; // start the slide from off-screen
    root.classList.add('is-open');
    openedAt = Date.now();
    setExpanded(true);
    root.querySelector('.okm-top [data-okm-close]')?.focus({preventScroll: true});
  };
  const finishClose = opts => {
    if (root.classList.contains('is-open')) return;
    root.hidden = true; root.classList.remove('is-closing');
    unlockScroll(); resetViews();
    if (!opts.keepFocus) (lastFocus && lastFocus.isConnected ? lastFocus : trigger())?.focus({preventScroll: true});
    opts.after && opts.after();
  };
  const close = (opts = {}) => {
    if (!isOpen()) return;
    root.classList.add('is-closing'); root.classList.remove('is-open');
    setExpanded(false);
    if (opts.instant || reduce.matches) { clearTimeout(closeTimer); finishClose(opts); return; }
    const sheet = root.querySelector('.okm-sheet');
    let done = false;
    const end = () => { if (done) return; done = true; clearTimeout(closeTimer); sheet.removeEventListener('transitionend', onEnd); finishClose(opts); };
    const onEnd = e => { if (e.target === sheet && e.propertyName === 'transform') end(); };
    sheet.addEventListener('transitionend', onEnd);
    closeTimer = setTimeout(end, CLOSE_MS + 120); // fallback if transitionend never fires
  };
  const go = id => {
    const next = root.querySelector(`[data-okm-view="${id}"]`);
    if (!next) return;
    const h = home();
    next.scrollTop = 0;
    h.classList.remove('is-active'); h.classList.add('is-behind'); h.inert = true; h.setAttribute('aria-hidden', 'true');
    next.classList.add('is-active'); next.inert = false; next.setAttribute('aria-hidden', 'false');
    setTimeout(() => next.querySelector('[data-okm-back]')?.focus({preventScroll: true}), 60);
  };
  const back = () => {
    const cur = root.querySelector('.okm-view.is-active:not([data-okm-view="home"])');
    const h = home();
    if (!cur) return;
    cur.classList.remove('is-active'); cur.inert = true; cur.setAttribute('aria-hidden', 'true');
    h.classList.remove('is-behind'); h.classList.add('is-active'); h.inert = false; h.setAttribute('aria-hidden', 'false');
    setTimeout(() => h.querySelector(`[data-okm-go="${cur.dataset.okmView}"]`)?.focus({preventScroll: true}), 60);
  };
  const headerSearch = () => document.querySelector('#OkSiteHeader input.site-header__search-input, #OkSiteHeader input[name="q"]');

  const init = () => {
    const found = document.getElementById('OkMobileMenu');
    if (!found || found === root) return;
    // The theme editor can re-render the header; drop any older copy already moved to <body>.
    document.querySelectorAll('body > .okm').forEach(el => { if (el !== found) el.remove(); });
    root = found;
    if (root.parentElement !== document.body) document.body.appendChild(root); // never trapped inside the header
    resetViews();
    if (phone.matches) trigger()?.setAttribute('aria-controls', 'OkMobileMenu');
    root.addEventListener('touchstart', () => {}, {passive: true}); // lets iOS show :active tap feedback
    root.addEventListener('click', e => {
      const t = e.target;
      // Ignore stray taps while the menu is still sliding in (a quick double-tap on the menu button).
      if (Date.now() - openedAt < SETTLE_MS && !t.closest('.okm-top [data-okm-close]')) { e.preventDefault(); return; }
      if (t.closest('[data-okm-close]')) { e.preventDefault(); close(); return; }
      const g = t.closest('[data-okm-go]'); if (g) { go(g.dataset.okmGo); return; }
      if (t.closest('[data-okm-back]')) { back(); return; }
      if (t.closest('[data-okm-search]')) {
        const input = headerSearch();
        if (!input) { location.href = '/search'; return; }
        // Focus inside the tap itself so iPhones raise the keyboard, then slide the menu away.
        try { input.focus({preventScroll: true}); } catch (_) { input.focus(); }
        close({keepFocus: true, instant: false});
        return;
      }
      const rw = t.closest('[data-okm-rewards]');
      if (rw) {
        // Open Stamped's rewards panel (points, redeeming, referrals). Fall back to the rewards page.
        const base = document.querySelector('.stamped-rewards-base');
        const fn = window.StampedFn && window.StampedFn.toggleRewardsModal;
        if (!base || typeof fn !== 'function') return; // let the link go to the rewards page
        e.preventDefault();
        const href = rw.href;
        close({keepFocus: true, after: () => {
          try { if (!base.classList.contains('opened')) window.StampedFn.toggleRewardsModal(); }
          catch (_) { location.href = href; return; }
          setTimeout(() => { if (!base.classList.contains('opened')) location.href = href; }, 700);
        }});
        return;
      }
      if (t.closest('[data-okm-cart]')) {
        const cart = document.getElementById('HeaderCartTrigger');
        if (cart) { e.preventDefault(); close({keepFocus: true, after: () => cart.click()}); }
      }
    });
  };
  // Escape and the focus trap, wherever focus happens to be while the menu is open.
  document.addEventListener('keydown', e => {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); root.querySelector('.okm-view.is-active:not([data-okm-view="home"])') ? back() : close(); return; }
    if (e.key !== 'Tab') return;
    const items = [...root.querySelectorAll('.okm-top a,.okm-top button,.okm-view.is-active a,.okm-view.is-active button')].filter(el => el.getClientRects().length);
    if (!items.length) return;
    const i = items.indexOf(document.activeElement);
    e.preventDefault();
    items[(i < 0 ? 0 : i + (e.shiftKey ? -1 : 1) + items.length) % items.length].focus();
  });
  // Take over the header's menu button on phones, before the theme's own handler sees the tap.
  document.addEventListener('click', e => {
    if (!phone.matches || !e.target.closest('#OkSiteHeader .mobile-menu-trigger')) return;
    init();
    if (!root) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    isOpen() ? close() : open();
  }, true);
  // The older header script resets aria-expanded on resize; keep it in step with this menu.
  window.addEventListener('resize', () => { if (phone.matches && root) requestAnimationFrame(() => setExpanded(isOpen())); }, {passive: true});
  phone.addEventListener('change', () => { if (!phone.matches && isOpen()) close({keepFocus: true, instant: true}); });
  // Leaving the page: shut instantly so the back/swipe preview never shows it open.
  window.addEventListener('pagehide', () => { if (root && !root.hidden) { root.classList.remove('is-open', 'is-closing'); root.hidden = true; unlockScroll(); setExpanded(false); } });
  // Fetch the small Enhansa photo once the page is idle, so it is ready before the first open.
  const warm = () => { init(); if (phone.matches) loadImages(); };
  window.addEventListener('load', () => (window.requestIdleCallback ? requestIdleCallback(warm, {timeout: 3000}) : setTimeout(warm, 1500)), {once: true});
  document.addEventListener('touchstart', e => { if (e.target.closest && e.target.closest('#OkSiteHeader .mobile-menu-trigger')) warm(); }, {passive: true, capture: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* Phones: no floating rewards button handled in CSS. */

/* Search: no autocorrect on search boxes (brand names like Klaire, Ther-Biotic), plus a "real person" help card when the dropdown finds nothing. */
(() => {
  if (!window.matchMedia('(max-width: 767px)').matches) return; // phones only; desktop search unchanged
  const fix = root => (root || document).querySelectorAll('input[name="q"], input[type="search"]').forEach(i => {
    if (i.dataset.okq) return; i.dataset.okq = '1';
    i.setAttribute('autocorrect', 'off'); i.setAttribute('autocapitalize', 'off'); i.setAttribute('spellcheck', 'false'); i.setAttribute('enterkeyhint', 'search');
  });
  const help = () => {
    const box = document.querySelector('#boost-pfs-search-suggestion-mobile .boost-pfs-search-suggestion');
    if (!box) return;
    const none = box.querySelector('.boost-pfs-search-suggestion-no-result');
    const have = box.querySelector('.okq-help');
    if (!none) { if (have) have.remove(); return; }
    if (have) return;
    const tel = document.querySelector('#OkMobileMenu a[href^="tel:"]');
    const mail = document.querySelector('#OkMobileMenu a[href^="mailto:"]');
    const d = document.createElement('div'); d.className = 'okq-help';
    d.innerHTML = '<span class="okq-help-ic" aria-hidden="true"></span><div><p class="okq-help-t">Still can’t find it?</p><p class="okq-help-s">Call or email us. A real person will help you find it.</p><p class="okq-help-l"></p></div>';
    const l = d.querySelector('.okq-help-l');
    if (tel) { const a = document.createElement('a'); a.href = tel.getAttribute('href'); a.textContent = 'Call us'; l.appendChild(a); }
    if (mail) { if (tel) l.appendChild(document.createTextNode(' · ')); const a = document.createElement('a'); a.href = mail.getAttribute('href'); a.textContent = 'Email us'; l.appendChild(a); }
    if (!tel && !mail) { const a = document.createElement('a'); a.href = 'mailto:info@ourkidsasd.com'; a.textContent = 'Email us'; l.appendChild(a); }
    none.insertAdjacentElement('afterend', d);
  };
  /* Keep the dropdown starting exactly under the search bar (iOS can size the bar differently). */
  /* The dropdown and the search bar are both pinned to the top of the screen, so iOS moves them together.
     The results just start below the bar's measured height (padding), instead of the dropdown being positioned separately. */
  const place = () => {
    const panel = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');
    if (!panel || getComputedStyle(panel).display === 'none') return;
    const h = panel.offsetHeight;
    if (h > 20 && h < 200) document.documentElement.style.setProperty('--okq-bar', h + 'px');
    const wrap = document.getElementById('boost-pfs-search-suggestion-mobile');
    if (wrap && wrap.style.getPropertyPriority('top') === 'important') wrap.style.removeProperty('top');
  };
  /* Boost adds the dropdown after the search bar, so with equal layers the dropdown paints on top of it.
     Moving the bar after the dropdown keeps the bar on top, so results can only slide under it. */
  const stack = () => {
    const panel = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');
    const wrap = document.getElementById('boost-pfs-search-suggestion-mobile');
    if (!panel || !wrap || panel.parentNode !== wrap.parentNode) return;
    if (panel.compareDocumentPosition(wrap) & Node.DOCUMENT_POSITION_FOLLOWING) {
      const active = document.activeElement;
      wrap.insertAdjacentElement('afterend', panel);
      if (active && panel.contains(active) && document.activeElement !== active) { try { active.focus({preventScroll: true}); } catch (_) {} }
    }
  };
  /* Products header: say these are the top matches and show the full count, so nobody thinks there are only 4. */
  const label = () => {
    const box = document.querySelector('#boost-pfs-search-suggestion-mobile .boost-pfs-search-suggestion');
    if (!box) return;
    const head = box.querySelector('.boost-pfs-search-suggestion-group[data-group="products"] li.boost-pfs-search-suggestion-header');
    const all = box.querySelector('.boost-pfs-search-suggestion-header-view-all a');
    if (!head) return;
    const m = all && all.textContent.match(/(\d[\d,]*)/);
    const want = 'Top matches' + (m ? '|' + m[1] : '');
    if (head.dataset.okq === want) return;
    head.dataset.okq = want;
    head.textContent = 'Top matches';
    if (m && all) {
      const a = document.createElement('a');
      a.className = 'okq-count'; a.href = all.getAttribute('href'); a.textContent = 'See all ' + m[1];
      head.appendChild(a);
    }
  };
  const run = () => { fix(); help(); stack(); place(); label(); };
  window.addEventListener('resize', () => place(), {passive: true});
  if (window.visualViewport) visualViewport.addEventListener('resize', () => place(), {passive: true});
  let t = 0; const mo = new MutationObserver(() => { if (!t) t = requestAnimationFrame(() => { t = 0; run(); }); });
  const start = () => { run(); mo.observe(document.body, {childList: true, subtree: true}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();

/* Tap outside a shell pop-up (on the dimmed area) closes it, like the product page sheets. */
document.addEventListener('click', e => { const d = e.target; if (d && d.tagName === 'DIALOG' && d.classList.contains('ok-shell-dialog') && d.open) { const r = d.getBoundingClientRect(); if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) d.close(); } });
/* Closing the search panel with the back arrow (without searching) clears what was typed.
   On the search results page the box goes back to the search that is showing.
   Boost keeps its own copy of the last text and puts it back when the box is tapped again,
   so after a close we also clear it again right after Boost reopens the panel. */
(() => {
  let stale = null;
  const resultsQ = () => document.body.classList.contains('template-search') ? (new URLSearchParams(location.search).get('q') || '') : '';
  const reset = () => {
    const q = resultsQ();
    document.querySelectorAll('input[name="q"]').forEach(i => { if (i.value !== q) i.value = q; });
    const clear = document.querySelector('.boost-pfs-search-btn-clear-suggestion');
    if (clear && !q) clear.style.display = 'none';
  };
  const onClose = e => {
    if (!e.target.closest || !e.target.closest('.boost-pfs-search-btn-close-suggestion')) return;
    const typed = [...document.querySelectorAll('input[name="q"]')].map(i => i.value).find(v => v) || '';
    if (typed && typed !== resultsQ()) stale = typed;
    setTimeout(reset, 0); setTimeout(reset, 250);
  };
  document.addEventListener('click', onClose, true);
  document.addEventListener('touchend', onClose, true);
  const onOpen = e => {
    if (!stale || !e.target.matches || !e.target.matches('input[name="q"]')) return;
    const fix = () => {
      if (!stale) return;
      let hit = false;
      document.querySelectorAll('input[name="q"]').forEach(i => { if (i.value === stale) { i.value = resultsQ(); hit = true; } });
      if (hit) { const c = document.querySelector('.boost-pfs-search-btn-clear-suggestion'); if (c && !resultsQ()) c.style.display = 'none'; const box = document.activeElement && document.activeElement.matches && document.activeElement.matches('input[name="q"]') ? document.activeElement : null; if (box) box.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Backspace' })); }
    };
    [0, 60, 200, 450].forEach(t => setTimeout(fix, t));
  };
  ['focusin', 'click', 'touchend'].forEach(ev => document.addEventListener(ev, onOpen, true));
  document.addEventListener('input', e => { if (e.target.matches && e.target.matches('input[name="q"]')) stale = null; }, true);
})();

/* Suggested searches: hide a suggestion that is the same as what was typed (it adds nothing and
   looks like a second search box). If no suggestions are left, hide that card. */
(() => {
  const norm = v => (v || '').toLowerCase().replace(/\s+/g, ' ').trim();
  let queued = false;
  const run = () => {
    queued = false;
    const panel = document.getElementById('boost-pfs-search-suggestion-mobile');
    if (!panel) return;
    const typed = norm([...document.querySelectorAll('input[name="q"]')].map(i => i.value).find(v => v && v.trim()));
    panel.querySelectorAll('.boost-pfs-search-suggestion-group[data-group="suggestions"]').forEach(g => {
      const items = [...g.querySelectorAll('li.boost-pfs-search-suggestion-item')];
      let left = 0;
      items.forEach(li => {
        const dup = !!typed && norm(li.getAttribute('data-title') || li.textContent) === typed;
        li.classList.toggle('ok-sug-dup', dup);
        if (!dup) left++;
      });
      g.classList.toggle('ok-sug-empty', left === 0);
    });
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(run); } };
  /* Watch the whole page only until Boost adds its panel, then watch just the panel. */
  const finder = new MutationObserver(() => {
    const panel = document.getElementById('boost-pfs-search-suggestion-mobile');
    if (!panel) return;
    finder.disconnect();
    new MutationObserver(queue).observe(panel, { childList: true, subtree: true });
    queue();
  });
  if (document.getElementById('boost-pfs-search-suggestion-mobile')) new MutationObserver(queue).observe(document.getElementById('boost-pfs-search-suggestion-mobile'), { childList: true, subtree: true });
  else finder.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('input', e => { if (e.target.matches && e.target.matches('input[name="q"]')) queue(); }, true);
})();

/* Header strip messages come from the Toolbar announcements in the theme editor.
   One message: shown as is. Several: they take turns. Any message about shipping gets the (i) pop-up button. */
(() => {
  const phone = window.matchMedia('(max-width: 767px)');
  let timer = 0;
  const init = () => {
    const strip = document.querySelector('#OkSiteHeader .ok-shipping-strip');
    if (!strip || strip.dataset.okAnn) return;
    const slides = [...document.querySelectorAll('[data-section-type="toolbar"] .announcement-slider__slide')];
    const texts = slides.map(sl => {
      const m = sl.querySelector('.medium-up--hide') || sl.querySelector('.announcement-slider__content') || sl;
      return m.textContent.replace(/\s+/g, ' ').trim();
    }).filter(Boolean);
    if (!texts.length) return;
    strip.dataset.okAnn = '1';
    const info = strip.querySelector('.ok-shipping-info');
    const icon = strip.querySelector(':scope > svg');
    const track = document.createElement('div');
    track.className = 'ok-ann-track';
    texts.forEach((t, i) => {
      const d = document.createElement('div');
      d.className = 'ok-ann-slide' + (i === 0 ? ' is-on' : '');
      const ship = /ship/i.test(t);
      if (ship && icon) d.appendChild(icon.cloneNode(true));
      const s = document.createElement('strong'); s.textContent = t; d.appendChild(s);
      if (ship && info) d.appendChild(info.cloneNode(true));
      if (i > 0) d.setAttribute('aria-hidden', 'true');
      track.appendChild(d);
    });
    [...strip.childNodes].forEach(n => { if (n.nodeType === 1 && n.tagName === 'DIALOG') return; n.remove(); });
    strip.insertBefore(track, strip.firstChild);
    strip.classList.add('ok-ann');
    if (texts.length < 2) return;
    let at = 0;
    const els = [...track.children];
    const show = i => els.forEach((el, k) => {
      el.classList.toggle('is-on', k === i);
      el.toggleAttribute('aria-hidden', k !== i);
      el.querySelectorAll('button,a').forEach(b => { b.tabIndex = k === i ? 0 : -1; });
    });
    show(0);
    const tick = () => { if (document.hidden || !phone.matches) return; at = (at + 1) % els.length; show(at); };
    clearInterval(timer); timer = setInterval(tick, 5000);
    strip.addEventListener('pointerenter', () => clearInterval(timer));
    strip.addEventListener('focusin', () => clearInterval(timer));
  };
  window.__okAnnInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', () => { const s = document.querySelector('#OkSiteHeader .ok-shipping-strip'); if (s) delete s.dataset.okAnn; init(); });
})();

/* UpCart slide cart restyle (phones). UpCart renders in a shadow root, so its look comes from ok-upcart.css loaded inside it.
   Text tweaks run on phones only, so the desktop cart stays exactly as UpCart draws it. */
(() => {
  const me = document.currentScript || document.querySelector('script[src*="ok-mobile-shell"]');
  if (!me || !me.src) return;
  const href = me.src.replace(/ok-mobile-shell\.js/, 'ok-upcart.css');
  const phone = window.matchMedia('(max-width: 767px)');
  let root = null, host = null, queued = 0;
  const schedule = () => { if (!queued) queued = requestAnimationFrame(tidy); };

  // Brand names: read once per product, kept for the visit, fetched one at a time and only while the cart is open.
  const vendors = {};
  const want = [];
  let busy = false;
  const store = (h, v) => { vendors[h] = v; try { sessionStorage.setItem('okv:' + h, v); } catch (e) {} };
  const pump = () => {
    if (busy || !want.length) return;
    const h = want.shift();
    busy = true;
    fetch('/products/' + h + '.js?upcart=1').then(r => r.ok ? r.json() : null).then(j => {
      if (j && typeof j.vendor === 'string') store(h, j.vendor); else delete vendors[h];
    }).catch(() => { delete vendors[h]; }).finally(() => { busy = false; schedule(); setTimeout(pump, 120); });
  };
  const vendorFor = h => {
    if (h in vendors) return vendors[h];
    let v = null;
    try { v = sessionStorage.getItem('okv:' + h); } catch (e) {}
    if (v !== null) { vendors[h] = v; return v; }
    vendors[h] = null;
    want.push(h);
    pump();
    return null;
  };
  const handleOf = a => { const m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; };
  const isOpen = () => { const c = root.querySelector('#CartPopup'); return !!c && /styles_active/.test(c.className); };

  const tidy = () => {
    queued = 0;
    if (!root || !host) return;
    if (!root.querySelector('link#ok-upcart')) {
      const l = document.createElement('link');
      l.id = 'ok-upcart'; l.rel = 'stylesheet'; l.media = '(max-width: 767px)'; l.href = href;
      root.appendChild(l);
    } else if (root.lastElementChild && root.lastElementChild.id !== 'ok-upcart' && root.lastElementChild.tagName === 'LINK') {
      root.appendChild(root.querySelector('link#ok-upcart'));
    }
    if (!phone.matches) return;
    const q = s => JSON.stringify(s);
    let n = 0;
    root.querySelectorAll('.upcart-public-cart-item input').forEach(i => { n += parseInt(i.value, 10) || 0; });
    host.style.setProperty('--ok-cart-title', q(n ? 'Your cart (' + n + ')' : 'Your cart'));
    const btn = root.querySelector('.upcart-checkout-button');
    const total = btn ? (btn.textContent.split(/[•·]/)[1] || '').trim() : '';
    host.style.setProperty('--ok-subtotal', q(total));
    // Option names before sizes ("Title:", "Size:", "Flavor:", "Quantity:") add noise next to the quantity stepper.
    root.querySelectorAll('.upcart-internal-cart-items__key-value-pair').forEach(el => {
      const t = el.textContent, c = t.replace(/^\s*[^:]{1,24}:\s+/, '');
      if (c !== t && c) el.textContent = c;
    });
    if (isOpen()) {
      root.querySelectorAll('.upcart-public-component-product-tile__product-title, .upcart-public-component-upsell-tile__title').forEach(t => {
        const a = t.closest('a') || t.querySelector('a');
        const h = handleOf(a);
        if (!h) return;
        const v = vendorFor(h);
        const el = t.classList.contains('upcart-public-component-upsell-tile__title') && a ? a : t;
        const val = v === null ? ' ' : v;   // keep the line's space while the name loads
        if (el.getAttribute('data-ok-vendor') !== val) el.setAttribute('data-ok-vendor', val);
      });
    }
    root.querySelectorAll('.upcart-public-upsell__title p').forEach(p => {
      const t = p.closest('[class*="styles_CartPreview__empty__body"]') ? 'Our bestsellers' : 'You might also like';
      if (p.textContent !== t) p.textContent = t;
    });
    root.querySelectorAll('.upcart-public-rewards').forEach(rw => {
      const on = /unlocked/i.test(rw.textContent);
      if (rw.classList.contains('ok-unlocked') !== on) rw.classList.toggle('ok-unlocked', on);
    });
    root.querySelectorAll('.upcart-public-rewards__message p').forEach(el => {
      const f = el.firstChild;
      if (f && f.nodeType === 3 && /^\s*\p{Extended_Pictographic}/u.test(f.data)) f.data = f.data.replace(/^\s*\p{Extended_Pictographic}️?\s*/u, '');
    });
    root.querySelectorAll('.upcart-public-component-product-tile__subscription-upgrade').forEach(w => {
      const on = !!w.querySelector('select');
      if (w.classList.contains('ok-sub-on') !== on) w.classList.toggle('ok-sub-on', on);
    });
    root.querySelectorAll('.upcart-public-component-product-tile__subscription-upgrade-btn').forEach(b => {
      const t = b.textContent.trim();
      if (!t) return;
      const pct = (t.match(/(\d+%)/) || [])[1];
      const label = pct ? 'Subscribe & save ' + pct : 'Subscribe & save';
      const name = 'Switch to ' + label;
      if (b.getAttribute('aria-label') !== name) b.setAttribute('aria-label', name);
      b.parentElement.style.setProperty('--ok-sub-label', q(label));
    });
  };
  const watch = () => {
    host = document.getElementById('upCart');
    if (!host || !host.shadowRoot) return false;
    root = host.shadowRoot;
    new MutationObserver(schedule).observe(root, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'value']});
    ['input', 'change', 'click'].forEach(ev => root.addEventListener(ev, () => { schedule(); setTimeout(schedule, 350); setTimeout(schedule, 1200); }, true));
    // Focus rings for keyboard users only; UpCart's own focus moves on open don't draw one after a tap.
    document.addEventListener('keydown', e => { if (e.key === 'Tab') host.classList.add('ok-kbd'); }, true);
    document.addEventListener('pointerdown', () => host.classList.remove('ok-kbd'), true);
    tidy();
    return true;
  };
  if (!watch()) {
    let tries = 0;
    const t = setInterval(() => { if (watch() || ++tries > 60) clearInterval(t); }, 500);
  }
})();
